import { mString } from 'lib/helpers/utility';

import AddServiceActions from '../components/AddServiceActions';

export const addServicesModalColumns = (isDental) => [
  {
    headerName: '',
    field: '',
    maxWidth: 40,
    headerCheckboxSelection: true,
    checkboxSelection: (params) => !params.node.group
  },
  {
    field: 'name',
    headerName: 'Name',
    sortable: false,
    flex: 1,
    valueGetter: (params) => params.data?.name || params.data?.cpt_description || ''
  },
  {
    field: 'code',
    headerName: 'Code',
    sortable: false,
    maxWidth: 120
  },
  {
    field: 'also_known_as',
    headerName: 'Also known as',
    sortable: false,
    flex: 1,
    valueGetter: (params) => params.data?.also_known_as || '-'
  },
  {
    field: 'par_amount',
    headerName: 'Allowable amount',
    ...(!isDental && {
      headerTooltip: 'Default allowable amounts are pulled from the Medicare fee schedule.'
    }),
    cellRenderer: ({ value }) => mString(value || 0),
    sortable: false
  },
  {
    field: 'standard_charge',
    headerName: 'Standard charge',
    cellRenderer: ({ value }) => mString(value || 0),
    sortable: false
  },
  {
    field: 'self_pay',
    headerName: 'Self pay',
    cellRenderer: ({ value }) => mString(value || 0),
    sortable: false,
    maxWidth: 120
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    maxWidth: 100,
    cellRenderer: AddServiceActions,
    pinned: 'right'
  }
];
